<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Gerenciamento de preços calculados em lote</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <div class="mb-3" v-show="!loading">
                <div class="top-button-container">
                    <button type="button" 
                        class="btn btn-primary mr-3"
                        :disabled="openingFilterModal"
                        @click="showFilterModal()">
                        Filtro

                        <Loading v-show="openingFilterModal" />
                    </button>

                    <button type="button" 
                        class="btn btn-outline-secondary" 
                        v-show="hasProductList"
                        @click="showPriceManagementByChannelModal()">
                        Aplicar novos preços
                    </button>                    

                    <div class="btn-group float-right">
                        <div class="btn-group">
                            <button type="button" 
                                class="btn btn-outline-secondary dropdown-toggle"
                                data-toggle="dropdown">
                                Ações do lote
                            </button>

                            <div class="dropdown-menu">
                                <span class="dropdown-item"
                                    @click="showModalClearCurrentBatchItems(currentBatch)">
                                    Limpar lote
                                </span>

                                <p class="dropdown-divider"></p>

                                <span class="dropdown-item"
                                    @click="showModalDeleteBatch(currentBatch)">
                                    Excluir lote
                                </span>
                            </div>
                        </div>
                    </div>                 
                </div>
            </div>

            <div>
                <div class="modal" id="muven-product-price-percentage-batch-list-filter-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Filtro de produtos</h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12 col-md-6 form-group">
                                        <label>Nome</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="productBatchFilterForm.name" />
                                    </div>

                                    <div class="col-12 col-md-3 form-group">
                                        <label>Código SKU</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="productBatchFilterForm.skuCode" />
                                    </div>

                                    <div class="col-12 col-md-3 form-group">
                                        <label>Código EAN</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="productBatchFilterForm.eanCode" />
                                    </div>

                                    <div class="col-12 form-group">
                                        <label>Descrição</label>
                                        <input type="text" 
                                            class="form-control" 
                                            v-model="productBatchFilterForm.description" />
                                    </div>

                                    <div class="col-12 col-md-8 form-group">
                                        <label>Qualidade</label>
                                        <multiselect
                                            v-model="productBatchFilterForm.qualityList"
                                            :options="qualityList"
                                            :multiple="true"
                                            :show-labels="false"
                                            label="description"
                                            track-by="enum"
                                            placeholder="" />
                                    </div>

                                    <div class="col-12 col-md-4 form-group">
                                        <label>Status</label>
                                        <multiselect
                                            v-model="productBatchFilterForm.isActive"
                                            :options="isActiveOptions"
                                            :multiple="false"
                                            :show-labels="false"
                                            label="description"
                                            track-by="bool"
                                            placeholder="" />
                                    </div>

                                    <div class="col-12 form-group">
                                        <label>Vinculado às categorias</label>
                                        <multiselect
                                            v-model="productBatchFilterForm.categoryList"
                                            :options="categoryList"
                                            :multiple="true"
                                            :show-labels="false"
                                            label="name"
                                            track-by="id"
                                            placeholder="" />
                                    </div>

                                    <div class="col-12 form-group">
                                        <label>Vinculado às marcas</label>
                                        <multiselect
                                            v-model="productBatchFilterForm.brandList"
                                            :options="brandList"
                                            :multiple="true"
                                            :show-labels="false"
                                            label="name"
                                            track-by="id"
                                            placeholder="" />
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" 
                                    class="btn btn-primary" 
                                    @click="getProductsWithFilter(currentBatch, productBatchFilterForm)"
                                    :disabled="loadingFilter || !this.productBatchFilterForm.isFilterFilled()">
                                        Adicionar ao lote

                                        <Loading v-show="loadingFilter" />
                                </button>

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="clearFilter()">Restaurar</button>

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="closeFilterModal()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-price-percentage-batch-management-by-channel-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Aplicar novos preços para {{productBatchPriceManagementByChannel.channelWrapper.name}}</h5>
                            </div>
                            <div class="modal-body">
                                <div class="">
                                    <div class="muven-tip muven-tip-standalone tip-info mb-3">
                                        <fa icon="info" class="tip-icon" />
                                        <p>Escolha a variação de preço a ser aplicada nos produtos do lote. Valores acima de 100% aumentar o preço dos produtos e valores abaixo de 100% diminuem os preços.</p>
                                        <br>
                                        <p>Exemplos: </p>
                                        <p>
                                            <ul class="mb-0 pl-3">
                                                <li>Variação 100%: Os preços são mantidos como estão;</li>
                                                <li>Variação 200%: Os preços tem seu valor dobrado;</li>
                                                <li>Variação 90%: Os preços sofrem um desconto de 10%.</li>
                                            </ul>
                                        </p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-12 form-group">
                                        <label>Ação</label>
                                        <multiselect
                                            v-model="productBatchPriceManagementByChannel.actionType"
                                            :options="productBatchPriceManagementByChannel.actionTypeList"
                                            :multiple="false"
                                            :show-labels="false"
                                            :allow-empty="false"
                                            track-by="enum"
                                            label="description"
                                            placeholder="" />
                                    </div>
                                </div>

                                <div class="row" v-show="productBatchPriceManagementByChannel.isActionTypeUseCurrentForm()">
                                    <div class="col-12 form-group">
                                        <label>Variação de preço em %</label>
                                        <input type="number"
                                            class="form-control"
                                            :class="{'is-invalid': !productBatchPriceManagementByChannel.isPricePercentageValid()}"
                                            step="1"
                                            min="0"
                                            :disabled="productBatchPriceManagementByChannel.isActionTypeUseChannelSettings()"
                                            v-model="productBatchPriceManagementByChannel.pricePercentage" />
                                        <small class="text-danger" v-show="!productBatchPriceManagementByChannel.isPricePercentageValid()">Percentual inválido.</small>                                        
                                    </div>

                                    <div class="col-12 form-group" >
                                        <label>Centavos</label>
                                        <SelectWrapperCmp 
                                            :show-remove-button="!!productBatchPriceManagementByChannel.priceDecimalsPreferenceString"
                                            :disabled="productBatchPriceManagementByChannel.isActionTypeUseChannelSettings()"
                                            @removed="handlePriceDecimalsPreferenceRemoved">
                                                <template v-slot:select>
                                                    <multiselect
                                                        v-model="productBatchPriceManagementByChannel.priceDecimalsPreferenceString"
                                                        :options="priceDecimals"
                                                        :multiple="false"
                                                        :show-labels="false"
                                                        :disabled="productBatchPriceManagementByChannel.isActionTypeUseChannelSettings()"
                                                        placeholder="" />
                                                    <small class="text-muted">Ao preencher este campo, todos os produtos terão o mesmo valor de centavos.</small>
                                                </template>
                                        </SelectWrapperCmp>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                 <button type="button" 
                                    class="btn btn-primary" 
                                    v-show="productBatchPriceManagementByChannel.isActionTypeUseCurrentForm()"
                                    :disabled="!productBatchPriceManagementByChannel.isValid() || submittingPriceManagementByChannel"
                                    @click="submitPriceManagementByChannel(currentBatch, productBatchPriceManagementByChannel)">                                    
                                    Executar
                                    <Loading v-show="submittingPriceManagementByChannel" />
                                </button>                               

                                 <button type="button" 
                                    class="btn btn-primary" 
                                    v-show="productBatchPriceManagementByChannel.isActionTypeUseChannelSettings()"
                                    :disabled="submittingPriceManagementByChannel"
                                    @click="restaurePriceManagementByChannel(currentBatch, productBatchPriceManagementByChannel)">                                    
                                    Restaurar
                                    <Loading v-show="submittingPriceManagementByChannel" />
                                </button>                               

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="closePriceManagementByChannelModal()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-price-percentage-batch-clear-current-batch-item-list-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Exclusão de itens do lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja excluir os itens do lote <b>{{currentBatch.name}}</b>?</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" 
                                    class="btn btn-outline-danger" 
                                    :disabled="clearingCurrentBatch"
                                    @click="clearBatchHandler(currentBatch)">
                                    <fa icon="exclamation-triangle" />

                                    Sim, excluir os itens

                                    <Loading v-show="clearingCurrentBatch" />                                   
                                </button>

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="closeModalClearCurrentBatchItems()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-price-percentage-batch-delete-batch-modal">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Exclusão de lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja excluir o lote <b>{{chosenBatchForExclusion.name}}</b>?</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" 
                                    class="btn btn-outline-danger" 
                                    :disabled="deletingCurrentBatch"
                                    @click="deleteBatchHandler(chosenBatchForExclusion)">
                                    <fa icon="exclamation-triangle" />

                                    Sim, excluir o lote

                                    <Loading v-show="deletingCurrentBatch" />                                   
                                </button>

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="closeModalDeleteBatch()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-price-percentage-batch-delete-product-from-batch-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Remover item do lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja excluir o produto <b>{{chosenProductForExclusion.name}}</b> <b v-show="!chosenProductForExclusion.hasChildren()">({{chosenProductForExclusion.skuCode}})</b> <span v-show="chosenProductForExclusion.hasChildren()"> e suas variações</span>?</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" 
                                    class="btn btn-outline-danger" 
                                    :disabled="deletingProductBatchItem"
                                    @click="deleteProductFromTheBatchHandler(currentBatch, chosenProductForExclusion)">
                                    <fa icon="exclamation-triangle" />

                                    Sim, remover do lote

                                    <Loading v-show="deletingProductBatchItem" />                                   
                                </button>

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="closeModalDeleteProductFromBatch()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal" id="muven-product-price-percentage-batch-delete-product-variation-from-batch-modal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Remover variação do lote</h5>
                            </div>
                            <div class="modal-body">
                                <div>
                                    <p>Tem certeza que deseja remover a variação <b>{{chosenProductVariationForExclusion.getVariationsStringified()}}</b> do produto <b>{{chosenProductForExclusion.name}}</b>?</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" 
                                    class="btn btn-outline-danger" 
                                    :disabled="deletingProductBatchItem"
                                    @click="deleteProductVariationFromTheBatchHandler(currentBatch, chosenProductForExclusion, chosenProductVariationForExclusion)">
                                    <fa icon="exclamation-triangle" />

                                    Sim, remover do lote

                                    <Loading v-show="deletingProductBatchItem" />                                   
                                </button>

                                <button type="button" 
                                    class="btn btn-outline-secondary" 
                                    @click="closeModalDeleteProductVariationFromBatch()">Fechar</button>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>

            <div>
                <Loading page v-show="loading" />

                <div class="muven-tip muven-tip-standalone tip-info mb-3" v-if="!loading">
                    <fa icon="info" class="tip-icon" />
                    <p>Apenas produtos que foram cadastrados ou associados no canal serão exibidos.</p>
                </div>

                <NothingFound v-if="!loading && !hasProductList" />

                <div class="table-responsive" v-show="hasProductList && !loading">
                    <table class="table table-hover table-sm">
                        <thead>
                            <tr>
                                <th class="product-name-width">Nome</th>
                                <th class="product-type-width">Tipo</th>
                                <th>SKU</th>
                                <th>Código retaguarda</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody v-for="(product, index) in productList" :key="index">
                            <tr>
                                <td class="col-5">{{product.name}}</td>
                                <td>
                                    <span v-show="!product.hasChildren()">Simples</span>
                                    <span v-show="product.hasChildren()"
                                        @click="toggleGridExhibition(product)">
                                        Grade 

                                        <fa icon="chevron-down" 
                                            class="icon-grid-toggle"
                                            :class="{
                                                'show-grid': product.isGridVisible,
                                            }"
                                        />
                                    </span>
                                </td>
                                <td>{{product.skuCode | infoOrPlaceholder}}</td>
                                <td>{{product.codeSource | infoOrPlaceholder}}</td>
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted btn-sm"
                                        @click="showModalDeleteProductFromBatch(product)">                                        
                                        <fa icon="trash-alt" />
                                    </button>
                                </td>
                            </tr>

                            <tr class="product-child" v-for="(child, index) in product.children" :key="index" v-show="product.isGridVisible">
                                <td class="col-5">{{child.getVariationsStringified()}}</td>
                                <td>Filho</td>
                                <td>{{child.skuCode | infoOrPlaceholder}}</td>                                
                                <td>{{child.codeSource | infoOrPlaceholder}}</td>                                
                                <td class="text-center muven-td-with-buttons">
                                    <button type="button" 
                                        class="btn btn-default text-muted"
                                        @click="showModalDeleteProductVariationFromBatch(product, child)">                                        
                                        <fa icon="trash-alt" />
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <ListCount :amount="productList.length" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ProductBatchItemListFilterModel} from '@/product/models/ProductBatchItemListFilterModel'
import modalService from '@/utils/services/ModalService'
import { flattenTree } from '../../utils/normalizers/TreeNormalizer'
import categoryService from '../../category/services/CategoryService'
import brandService from '../../brand/services/BrandService'
import ConfirmationExclusionModalCmp from '../../utils/components/ConfirmationExclusionModalCmp.vue'
import { ProductBatchModel } from '../models/ProductBatchModel'
import { mapState } from 'vuex'
import productBatchService from '../services/ProductBatchService'
import { cloneDeep } from 'lodash'
import {infoOrPlaceholder} from '@/utils/filters/InformationOrPlaceholderFilter'
import { ProductBatchPricePercentageManagementByChannelModel } from '../models/ProductBatchPricePercentageManagementByChannelModel'
import SelectWrapperCmp from '@/utils/components/SelectWrapperCmp'
import { ProductModel } from '../models/ProductModel'
import { priceDecimals } from "@/utils/constants/PriceDecimals" 

const ID_FILTER_MODAL = '#muven-product-price-percentage-batch-list-filter-modal'
const ID_PRICE_MANAGEMENT_BY_CHANNEL_MODAL = '#muven-product-price-percentage-batch-management-by-channel-modal'
const ID_CLEAR_CURRENT_BATCH_ITEM_LIST_MODAL = '#muven-product-price-percentage-batch-clear-current-batch-item-list-modal'
const ID_DELETE_BATCH_MODAL = '#muven-product-price-percentage-batch-delete-batch-modal'
const ID_DELETE_PRODUCT_FROM_BATCH_MODAL = '#muven-product-price-percentage-batch-delete-product-from-batch-modal'
const ID_DELETE_PRODUCT_VARIATION_FROM_BATCH_MODAL = '#muven-product-price-percentage-batch-delete-product-variation-from-batch-modal'

export default {
    name: 'ProductListBatchStockManagementView',
    components: {
        ConfirmationExclusionModalCmp,
        SelectWrapperCmp,
    },
    filters: {
        infoOrPlaceholder,
    },
    data() {
        return {
            priceDecimals,
            loading: false,
            loadingFilter: false,
            openingFilterModal: false,
            clearingCurrentBatch: false,
            deletingCurrentBatch: false,
            deletingProductBatchItem: false,
            submittingPriceManagementByChannel: false,
            newBatch: new ProductBatchModel(),
            currentBatch: new ProductBatchModel(),
            productBatchFilterForm: new ProductBatchItemListFilterModel(),
            productBatchFilterFormSubmitted: new ProductBatchItemListFilterModel(),
            productBatchPriceManagementByChannel: new ProductBatchPricePercentageManagementByChannelModel(),
            chosenBatchForExclusion: new ProductModel(),
            chosenProductForExclusion: new ProductModel(),
            chosenProductVariationForExclusion: new ProductModel(),
            batchList: [],
            productList: [],
            categoryList: [],
            brandList: [],
            qualityList: ProductBatchItemListFilterModel.getQualityList(),
            isActiveOptions: [
                {
                    bool: true,
                    description: 'Ativo',
                },
                {
                    bool: false,
                    description: 'Inativo',
                },
            ],
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Produtos',
                    path: '/produtos',
                },
                {
                    id: 1,
                    description: `Lotes de produtos`,
                    path: '/produtos/lotes',
                },
                {
                    id: 2,
                    description: `Carregando informações do lote`,
                    path: '',
                },
            ],
        }
    },
    async mounted() {
        this.loading = true

        try {
            this.batchList = await productBatchService.getBatchList()

            if (!this.batchList.length) {
                this.$router.push('/produtos/lotes')
                return
            }

            this.currentBatch = this.batchList.find((b) => String(b.id) === (this.$route.params.id))
            this.productBatchPriceManagementByChannel = new ProductBatchPricePercentageManagementByChannelModel(this.currentBatch.payload)
            this._updateBreadcrumbScenario(this.currentBatch)
            
            const productBatchItemListWrapped = await productBatchService.getBatchItems(this.currentBatch)
            this.productList = this._normalizeProductBatchItems(productBatchItemListWrapped)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async getProductsWithFilter(currentBatch, filterList) {
            this.productBatchItemFilterFormSubmitted = cloneDeep(filterList)
            this.loadingFilter = true

            try {
                const productBatchItemListWrapped = await productBatchService.addItems(currentBatch, filterList)
                const productBatchItemListNormalized = this._normalizeProductBatchItems(productBatchItemListWrapped)

                let parentProductFound = false

                for (const product of this.productList) {
                    if (product.hasChildren()) {
                        for (const productBatchItem of productBatchItemListNormalized) {
                            if (product.id === productBatchItem.id) {
                                parentProductFound = true
                                product.children.push(...productBatchItem.children)
                                break
                            }
                        }
                    }
                }

                if (!parentProductFound) {
                    this.productList.unshift(...productBatchItemListNormalized)
                }

                await this.closeFilterModal()
            } catch (e) {
                this.$floatingAlert.error({
                    message: e.message,
                })
            }

            this.loadingFilter = false
        },
        async clearBatchHandler(currentBatch) {
            this.clearingCurrentBatch = true

            try {
                await productBatchService.clearBatchItemList(currentBatch.id)

                this._clearProductList()
                this.closeModalClearCurrentBatchItems()

                this.$floatingAlert.success({
                    message: `Lote <b>${currentBatch.name}</b> limpo com sucesso.`,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.clearingCurrentBatch = false
        },
        async deleteBatchHandler(batch) {
            this.deletingCurrentBatch = true

            try {
                await productBatchService.deleteBatch(batch.id)

                this.$floatingAlert.success({
                    message: `Lote <b>${batch.name}</b> excluído com sucesso.`,
                })
                   
                await modalService.hide(ID_DELETE_BATCH_MODAL)
                this.$router.push('/produtos/lotes')
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.deletingCurrentBatch = false
        },
        async deleteProductFromTheBatchHandler(currentBatch, product) {
            this.deletingProductBatchItem = true

            try {
                await this._removeProductBatchItemFromTheList(currentBatch, product)
                this.closeModalDeleteProductFromBatch()

                this.$floatingAlert.success({
                    message: `Produto <b>${product.name}</b> (${product.skuCode}) removido do lote <b>${currentBatch.name}</b> com sucesso.`,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.deletingProductBatchItem = false
        },
        async deleteProductVariationFromTheBatchHandler(currentBatch, product, variation) {
            this.deletingProductBatchItem = true

            try {
                await productBatchService.deleteItemFromBatch(currentBatch.id, variation.id)

                let foundVariation = false

                for (let i = 0; i < this.productList.length; i++) {
                    if (this.productList[i].id === product.id) {
                        for (let j = 0; j < this.productList[i].children.length; j++) {
                            if (this.productList[i].children[j].id === variation.id) {
                                this.productList[i].children.splice(j, 1)
                                foundVariation = true
                                break
                            }
                        }

                        if (foundVariation) {
                            if (!this.productList[i].hasChildren()) {
                                await this._removeProductBatchItemFromTheList(currentBatch, product)
                            }

                            break
                        }
                    }
                }

                this.closeModalDeleteProductVariationFromBatch()

                this.$floatingAlert.success({
                    message: `Variação <b>${product.getVariationsStringified()}</b> do produto <b>${product.name} (${product.skuCode})</b> removido do lote <b>${currentBatch.name}</b> com sucesso.`,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.deletingProductBatchItem = false
        },
        async showFilterModal() {
            this.openingFilterModal = true

            try {
                if (!this.categoryList.length || !this.brandList.length) {
                    const result = await Promise.all([
                        categoryService.getCategoryTree(),
                        brandService.getAllBrands(),
                    ])

                    this.categoryList = flattenTree(result[0])
                    this.brandList = result[1]
                }

                await modalService.show(ID_FILTER_MODAL)
            } catch(err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.openingFilterModal = false
        },
        clearFilter() {
            this.productBatchFilterForm = new ProductBatchItemListFilterModel()
        },
        async closeFilterModal() {
            await modalService.hide(ID_FILTER_MODAL)
        },
        async submitPriceManagementByChannel(currentBatch, productBatchPriceManagementByChannel) {
            this.submittingPriceManagementByChannel = true

            try {
                await productBatchService.executeBatchAction(currentBatch.id, productBatchPriceManagementByChannel.normalize())

                this.$floatingAlert.info({
                    message: `Processamento dos preços para o canal ${productBatchPriceManagementByChannel.channelWrapper.name} em andamento.`,
                })

                await this.closePriceManagementByChannelModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingPriceManagementByChannel = false
        },
        async restaurePriceManagementByChannel(currentBatch, productBatchPriceManagementByChannel) {
            this.submittingPriceManagementByChannel = true

            try {
                await productBatchService.executeBatchAction(currentBatch.id, productBatchPriceManagementByChannel.normalizeForRestauration())

                this.$floatingAlert.info({
                    message: `Restauração dos preços do canal ${productBatchPriceManagementByChannel.channelWrapper.name} em andamento.`,
                })

                await this.closePriceManagementByChannelModal()
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }

            this.submittingPriceManagementByChannel = false
        },
        async showPriceManagementByChannelModal() {
            await modalService.show(ID_PRICE_MANAGEMENT_BY_CHANNEL_MODAL)
        },
        async closePriceManagementByChannelModal() {
            await modalService.hide(ID_PRICE_MANAGEMENT_BY_CHANNEL_MODAL)
        },
        async showModalClearCurrentBatchItems() {
            await modalService.show(ID_CLEAR_CURRENT_BATCH_ITEM_LIST_MODAL)
        },
        async closeModalClearCurrentBatchItems() {
            await modalService.hide(ID_CLEAR_CURRENT_BATCH_ITEM_LIST_MODAL)
        },
        async showModalDeleteBatch(batch) {
            this.chosenBatchForExclusion = batch
            await modalService.show(ID_DELETE_BATCH_MODAL)
        },
        async closeModalDeleteBatch() {
            await modalService.hide(ID_DELETE_BATCH_MODAL)
        },
        async showModalDeleteProductFromBatch(product) {
            this.chosenProductForExclusion = cloneDeep(product)

            await modalService.show(ID_DELETE_PRODUCT_FROM_BATCH_MODAL)
        },
        async closeModalDeleteProductFromBatch() {
            await modalService.hide(ID_DELETE_PRODUCT_FROM_BATCH_MODAL)
        },
        async showModalDeleteProductVariationFromBatch(product, variation) {
            this.chosenProductForExclusion = cloneDeep(product)
            this.chosenProductVariationForExclusion = cloneDeep(variation)

            await modalService.show(ID_DELETE_PRODUCT_VARIATION_FROM_BATCH_MODAL)
        },
        async closeModalDeleteProductVariationFromBatch() {
            await modalService.hide(ID_DELETE_PRODUCT_VARIATION_FROM_BATCH_MODAL)
        },
        toggleGridExhibition(product) {
            product.isGridVisible = !product.isGridVisible
        },
        _normalizeProductBatchItems(productBatchItemList) {
            return productBatchItemList.map((prodWrapper) => {
                return ProductModel.normalizeV1(prodWrapper.product, this.subscriber)
            })
        },
        _clearProductList() {
            this.productList = []
        },
        _updateBreadcrumbScenario(currentBatch) {
            this.breadcrumbList[2].description = `Gerenciamento de preço calculado (${this.productBatchPriceManagementByChannel.channelWrapper.name}): ${currentBatch.name}`
        },
        handlePriceDecimalsPreferenceRemoved() {
            this.productBatchPriceManagementByChannel.priceDecimalsPreferenceString = null
        },
        async _removeProductBatchItemFromTheList(currentBatch, product) {
            await productBatchService.deleteItemFromBatch(currentBatch.id, product.id)

            for (let i = 0; i < this.productList.length; i++) {
                if (this.productList[i].id === product.id) {
                    this.productList.splice(i, 1)
                    break
                }
            }
        }, 
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
            storeList: state => state.storeList,
            subscriber: state => state.subscriber,
        }),
        hasBatchList() {
            return this.batchList.length > 0
        },
        hasProductList() {
            return this.productList.length > 0
        },
    },
}
</script>

<style lang="scss" scoped>
.product-attributes {
    color: var(--text-muted);
    font-size: .85em;
}

.product-child {
    td {
        &:first-of-type {
            padding-left: 54px;
        }

        .grid-info {
            color: var(--text-muted);
            font-size: .9em;
        }
    }
}

.table {
    thead {
        tr {
            th.product-name-width {
                width: 250px;
            }

            th.product-type-width {
                width: 100px;
            }
        }
    }

    tbody {
        tr td {
            .icon-grid-toggle {
                cursor: pointer;
                font-size: .75em;
                color: var(--text-muted);
                margin-right: 15px;
                margin-left: 8px;
                transition: transform .3s ease;

                &.show-grid {
                    transform: rotate(180deg);
                }
            }
        }

        &:last-of-type tr {
            border-bottom: 1px solid var(--border);
        }

        &:nth-of-type(odd) tr {
            background-color: color-mix(in srgb, var(--text-strong) 5%, transparent); 

            &:hover {
                background-color: var(--surface-2);
            }
        }
    }
}

.batch-container {
    border: 1px solid var(--border);
    border-radius: 2px;

    .batch-info,
    .batch-actions {
        padding: 8px;
    }

    .batch-info {
        position: relative;

        .batch-remove-button-container {
            position: absolute;
            top: 8px;
            right: 8px;
        }
    }

    .batch-actions {
        overflow-x: hidden;
        border-top: 1px solid var(--border);
        background-color: var(--surface-2);
        text-align: right;
    }
}

#muven-product-price-percentage-batch-batch-list-management-modal {
    .modal-body {
        max-height: 500px;
        overflow-y: auto;
    }
}
</style>